<!-- eslint-disable @angular-eslint/template/eqeqeq -->
@let value = $value() !== undefined ? $_value() : $controlValue();
@let disabled = $disabled() !== undefined ? $disabled() : $controlDisabled();
@let placeholder = $displayPlaceholder();
@let controlPosition = $controlPosition();
@let verticalAlignment = $verticalAlignment() === 'center' ? 'items-center' : $verticalAlignment() === 'start' ? 'items-start' : 'items-end';
<label
  [class]="'px-1 flex' + (controlPosition === 'default' || controlPosition === 'opposite' ? ' items-center' : ' flex-col ' + verticalAlignment)"
  [style.padding]="$innerPadding()"
  [style.gap]="$gap() | cssValue"
  [class.disab]="disabled"
  [class.readonly]="$readonly()"
  [matTooltip]="!disabled ? $tooltip() : $tooltipWhenDisabled()"
>
  @if ($label() !== null) {
  <p
    [class]="($readonly() ? '' : 'select-none ') + ($labelWrap() ? '' : ' whitespace-nowrap') + (controlPosition === 'opposite' || controlPosition === 'top' ? ' order-1' : '')"
    [style.fontSize]="$labelFontSize() | cssValue"
    [style.fontWeight]="$labelWeight()"
    [style.color]="'var(' + $labelColor() + ')'"
  >{{ $label() }}</p>
  }
  <span class="inline-block relative w-full">
    <div class="grid items-center">
      <select
        #input
        class="input"
        [value]="value ?? ''"
        [disabled]="disabled || $readonly()"
        [class.has-placeholder]="placeholder !== null && (value === null || value === undefined || value === '')"
        [class.is-loading]="$loading()"
        [style.width]="$inputWidth()"
        (change)="onValueChange($event)"
      >
        @if (placeholder !== null) {
        <option value="" [disabled]="$disablePlaceholder()">{{ placeholder }}</option>
        }
        @for (item of $items(); track item) {
        <option [value]="item.key">{{ (item.value | asSignal)() }}</option>
        }
      </select>
    </div>
    <span class="side-element">
     @if (!$loading()) {
      <app-icon icon="arrow" [scale]="1.2" color="--select-arrow-icon" />
     }
     @else {
      <app-spinner />
     }
    </span>
  </span>
</label>
